import {
  AustraliaFlagIcon,
  CanadaFlagIcon,
  CzechRepublicFlagIcon,
  EuropeanUnionFlagIcon,
  GreatBritainFlagIcon,
  HongKongFlagIcon,
  JapanFlagIcon,
  MexicoFlagIcon,
  NewZealandFlagIcon,
  NigeriaFlagIcon,
  NorwayFlagIcon,
  PolandFlagIcon,
  SingaporeFlagIcon,
  SpainFlagIcon,
  SwitzerlandFlagIcon,
  TanzaniaFlagIcon,
  TurkeyFlagIcon,
  UgandaFlagIcon,
  USAFlagIcon,
} from "../Icons";

export type Icon = React.FunctionComponent<React.SVGProps<SVGSVGElement>>;

export const flagsMap = new Map<string, Icon>([
  ["AUD", AustraliaFlagIcon],
  ["CAD", CanadaFlagIcon],
  ["CZK", CzechRepublicFlagIcon],
  ["EUR", EuropeanUnionFlagIcon],
  ["GBP", GreatBritainFlagIcon],
  ["HKD", HongKongFlagIcon],
  ["JPY", JapanFlagIcon],
  ["MXN", MexicoFlagIcon],
  ["NZD", NewZealandFlagIcon],
  ["NGN", NigeriaFlagIcon],
  ["NOK", NorwayFlagIcon],
  ["PLN", PolandFlagIcon],
  ["SGD", SingaporeFlagIcon],
  ["ESP", SpainFlagIcon],
  ["CHF", SwitzerlandFlagIcon],
  ["TZS", TanzaniaFlagIcon],
  ["TRY", TurkeyFlagIcon],
  ["UGX", UgandaFlagIcon],
  ["USD", USAFlagIcon],
]);
